import React from "react";

const CustomInputUpdated = (props) => {
  const { label, placeholder, onChange, value, type, name, id } = props;
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "4px",
        width: "100%",
        alignItems: "start",
      }}
    >
      <label
        style={{
          fontWeight: "bold",
          width: "100%",
          textAlign: "left",
          color: "black",
          fontSize: "14px",
        }}
        htmlFor={id}
      >
        {label}
      </label>
      <input
        type={type}
        name={name}
        id={id}
        style={{
          width: "100%",
          border: "1px solid lightgrey",
          padding: "8px 10px",
          borderRadius: "5px",
          backgroundColor: "#E7E7E7E7",
        }}
        placeholder={placeholder}
        onChange={onChange}
        value={value}
      />
    </div>
  );
};

export default CustomInputUpdated;
